<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterCustomerRepair"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getCustomerRepairFlow">
              {{ $t('quotation_item_new_install_search') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="customerRepairDataTableHeaders"
      :items="customerRepairList"
      class="elevation-1 mt-5"
      :loading="isLoadingCustomerRepair"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_repair_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditCustomerRepairDialog" fullscreen persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
                {{ $t('common_new') }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ customerRepairDialogTitle }}</span>
                <v-spacer></v-spacer>
                <!-- <v-btn text small @click="chooseSelectItem" class="mx-2">
                  <v-icon>
                    mdi-content-copy
                  </v-icon>
                </v-btn> -->
              </v-card-title>
              <v-card-text>
                <v-container>
                  <ValidationObserver ref="customerRepair">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <customer-autocomplete
                          refName="customerAutocomplete"
                          :fatherEditedCustomer="editedCustomerRepair"
                          :editedCustomerIndex="-1"
                          :customerName="'quotation_customer_number'"
                          @setCustomer="setCustomer"
                          @keyupEnter="focusNextInput"
                          v-if="editedCustomerRepairIndex === -1"
                        />
                        <ValidationProvider
                          :name="$t('quotation_customer_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedCustomerRepair.CustomerNumber"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_customer_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('quotation_shortname')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepair.CustomerName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_shortname') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('quotation_full_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepair.CustomerFullName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_full_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">Item</v-tab>
                <v-tab href="#tab-2">BOM</v-tab>
                <v-tab-item value="tab-1">
                  <customer-repair-item
                    :customerRepairItems="editedCustomerRepair.CustomerRepairItems"
                    :isAllTextFieldDisable="isAllTextFieldDisable || isLoadingCustomerRepair"
                    @setEditedCustomerRepairItemIndex="setEditedCustomerRepairItemIndex"
                    @addEditedCustomerRepairItem="addEditedCustomerRepairItem"
                    @confirmDeleteCustomerRepairItem="confirmDeleteCustomerRepairItem"
                  />
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <customer-repair-bom
                    :customerId="editedCustomerRepair.CustomerId"
                    :customerRepairBoms="editedCustomerRepair.CustomerRepairBoms"
                    :isAllTextFieldDisable="isAllTextFieldDisable || isLoadingCustomerRepair"
                    @setEditedCustomerRepairBomIndex="setEditedCustomerRepairBomIndex"
                    @addEditedCustomerRepairBom="addEditedCustomerRepairBom"
                    @confirmDeleteCustomerRepairBom="confirmDeleteCustomerRepairBom"
                  />
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedCustomerRepair"
                  :disabled="isAllTextFieldDisable"
                  :loading="isLoadingCustomerRepair"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedCustomerRepair"
                  :loading="isLoadingSaveBtn"
                  :disabled="isLoadingCustomerRepair"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteCustomerRepairDialog"
            :deleteMessage="'item_group_delete_dialog_message'"
            @closeDelete="closeDeleteCustomerRepair"
            @confirmDelete="confirmDeleteCustomerRepair"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.UpdateTime`]="{ item }">
        {{ convertToDateTimeFormat(item.UpdateTime) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditCustomerRepairDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <!-- <v-icon small class="mr-2" @click="isShowDeleteCustomerRepairDialogBtn(item)">
          mdi-delete
        </v-icon> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import { HttpCustomerRepair } from '@/js/http-Manager'
import { mapGetters } from 'vuex'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import CustomerRepairItem from '@/components/CustomerRepair/CustomerRepairItem.vue'
import CustomerRepairBom from '@/components/CustomerRepair/CustomerRepairBom.vue'
export default {
  components: {
    DeleteDialog,
    CustomerAutocomplete,
    CustomerAutocompleteFilter,
    CustomerRepairItem,
    CustomerRepairBom
  },
  name: 'CustomerRepair',
  data: () => ({
    isShowEditCustomerRepairDialog: false,
    isShowDeleteCustomerRepairDialog: false,
    customerRepairList: [],
    editedCustomerRepairIndex: -1,
    searchCustomerRepair: '',
    editedCustomerRepair: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      UpdateTime: 0,
      CustomerRepairItems: [],
      CustomerRepairBoms: []
    },
    defaultCustomerRepair: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      UpdateTime: 0,
      CustomerRepairItems: [],
      CustomerRepairBoms: []
    },
    isLoadingCustomerRepair: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    filterCustomerRepair: {
      CustomerId: ''
    },
    editedCustomerRepairItemIndex: -1,
    editedCustomerRepairBomIndex: -1
  }),
  watch: {},
  async mounted () {
    await this.getCustomerRepairFlow()
  },
  computed: {
    customerRepairDialogTitle () {
      return this.editedCustomerRepairIndex === -1
        ? this.$t('customer_repair_add_card_title')
        : this.$t('customer_repair_edited_card_title')
    },
    customerRepairDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber'
        },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('item_update_time'), align: 'center', value: 'UpdateTime' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },

    ...mapGetters('login', {
      getUserAccountId: 'getUserAccountId'
    }),
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getCustomerRepairFlow () {
      await this.countTotalRows()
      await this.getCustomerRepair()
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },

    async setCustomer (val) {
      let existCustomer = this.customerRepairList.findIndex((x) => x.CustomerId === val.Id) !== -1
      if (existCustomer) {
        alert('此客戶已存在')
      }
      this.editedCustomerRepair.CustomerId = val.Id
      this.editedCustomerRepair.CustomerNumber = val.Number
      this.editedCustomerRepair.CustomerName = val.ShortName
      this.editedCustomerRepair.CustomerFullName = val.FullName
      this.editedCustomerRepair = JSON.parse(JSON.stringify(this.editedCustomerRepair))
    },
    setFilterCustomer (val) {
      this.filterCustomerRepair.CustomerId = val.Id
      this.filterCustomerRepair = JSON.parse(JSON.stringify(this.filterCustomerRepair))
    },

    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          customerId: this.filterCustomerRepair.CustomerId
        }
        if (this.countTotalRowsSource) {
          this.countTotalRowsSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.countTotalRowsSource = cancelToken.source()
        let response = await HttpCustomerRepair.GetAllCustomerRepairCount(
          param,
          this.countTotalRowsSource.token
        )
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getCustomerRepair(val)
    },
    async getCustomerRepair (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        await this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingCustomerRepair = true

      let param = {
        CustomerId: this.filterCustomerRepair.CustomerId,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc:
          typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }
      let response = await HttpCustomerRepair.GetAllCustomerRepair(param)
      this.isLoadingCustomerRepair = false
      this.customerRepairList = response && response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async saveEditedCustomerRepair () {
      let notExistCustomer =
        this.editedCustomerRepair.Id !== ''
          ? this.customerRepairList.findIndex(
            (x) =>
              x.Id !== this.editedCustomerRepair.Id &&
                x.CustomerId === this.editedCustomerRepair.CustomerId
          ) === -1
          : this.customerRepairList.findIndex(
            (x) => x.CustomerId === this.editedCustomerRepair.CustomerId
          ) === -1
      if (
        this.editedCustomerRepair.CustomerRepairItems.length === 0 &&
        this.editedCustomerRepair.CustomerRepairBoms.length === 0
      ) {
        alert('單身不得為空')
      } else if (notExistCustomer) {
        const isValid = await this.$refs.customerRepair.validate()
        if (isValid) {
          this.isLoadingSaveBtn = true
          this.isAllTextFieldDisable = true
          this.isLoadingCustomerRepair = true

          if (this.editedCustomerRepairIndex > -1) {
            await HttpCustomerRepair.UpdateCustomerRepair(this.editedCustomerRepair)
          } else {
            await HttpCustomerRepair.AddCustomerRepair(this.editedCustomerRepair)
          }
          this.closeEditedCustomerRepair()
        }
      } else {
        alert('此客戶已存在')
      }
    },
    async closeEditedCustomerRepair () {
      this.isLoadingCustomerRepair = true
      await this.getCustomerRepair()
      this.isShowEditCustomerRepairDialog = false
      this.isLoadingCustomerRepair = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultCustomerRepair)
        this.editedCustomerRepair = JSON.parse(str)
        this.editedCustomerRepairIndex = -1
        this.$refs.customerRepair.reset()
      })
    },
    async isShowEditCustomerRepairDialogBtn (item) {
      this.editedCustomerRepairIndex = this.customerRepairList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedCustomerRepair = JSON.parse(str)
      this.isShowEditCustomerRepairDialog = true
    },
    async isShowDeleteCustomerRepairDialogBtn (item) {
      this.editedCustomerRepairIndex = this.customerRepairList.indexOf(item)
      this.isShowDeleteCustomerRepairDialog = true
    },
    async confirmDeleteCustomerRepair () {
      this.isAllTextFieldDisable = true
      this.isLoadingCustomerRepair = true
      this.isLoadingSaveBtn = true
      await HttpCustomerRepair.DeleteCustomerRepair(
        this.customerRepairList[this.editedCustomerRepairIndex].Id
      )
      this.closeDeleteCustomerRepair()
    },
    async closeDeleteCustomerRepair () {
      this.isShowDeleteCustomerRepairDialog = false
      this.isAllTextFieldDisable = false
      this.isLoadingSaveBtn = false
      this.isLoadingCustomerRepair = false
      this.$nextTick(() => {
        this.editedCustomerRepairIndex = -1
      })
      await this.getCustomerRepair()
    },
    setEditedCustomerRepairItemIndex (val) {
      this.editedCustomerRepairItemIndex = val
    },
    async addEditedCustomerRepairItem (val) {
      if (this.editedCustomerRepairItemIndex === -1) {
        val.IsAdd = true
        this.editedCustomerRepair.CustomerRepairItems.push(val)
      } else {
        this.editedCustomerRepair.CustomerRepairItems.splice(
          this.editedCustomerRepairItemIndex,
          1,
          val
        )
      }
    },
    confirmDeleteCustomerRepairItem (val) {
      this.editedCustomerRepair.CustomerRepairItems.splice(val, 1)
    },
    setEditedCustomerRepairBomIndex (val) {
      this.editedCustomerRepairBomIndex = val
    },
    addEditedCustomerRepairBom (val) {
      if (this.editedCustomerRepairBomIndex === -1) {
        val.IsAdd = true
        if (!this.editedCustomerRepair.CustomerRepairBoms) {
          this.editedCustomerRepair.CustomerRepairBoms = []
        }
        this.editedCustomerRepair.CustomerRepairBoms.push(val)
      } else {
        this.editedCustomerRepair.CustomerRepairBoms.splice(
          this.editedCustomerRepairBomIndex,
          1,
          val
        )
      }
      this.editedCustomerRepair = JSON.parse(JSON.stringify(this.editedCustomerRepair))
    },
    confirmDeleteCustomerRepairBom (val) {
      this.editedCustomerRepair.CustomerRepairBoms.splice(val, 1)
      this.editedCustomerRepair = JSON.parse(JSON.stringify(this.editedCustomerRepair))
    }
  }
}
</script>
